<template>
	<v-card v-bind="$attrs">
		<v-toolbar
			v-if="$slots.title || $slots['bar-actions']"
			:dark="dark"
			dense
			:color="color"

		>
			<v-toolbar-title>
				<slot name="title" />
			</v-toolbar-title>
			<div class="flex-grow-1" />

			<v-toolbar-items>
				<slot name="bar-actions" />
			</v-toolbar-items>
		</v-toolbar>

		<v-card-text class="pa-2">
			<v-row>
				<v-col>
					<slot />
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
	export default {
		name: "c-card",
		components: {},
		props: {
			color: { type: String, default: "blue" },
			dark: { type: Boolean, default: true },
		},
		data () {
			return {};
		},
		computed: {},
		watch: {},
		created () {
		},
		mounted () {
		},
		updated () {
		},
		destroyed () {
		},
		methods: {},
	};
</script>

<style scoped>

</style>
